var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-full"},[_c('h6',{staticClass:"vs-input--label mb-3 mt-5"},[_vm._v(_vm._s(_vm.$t('MODULE.titleScala')))]),_c('Options',{attrs:{"index":_vm.index}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }